import { INDUSTRY_TEMPLATES } from "./industryTemplates";
import { OVERRIDES } from "./overrides";
import { mergeConfig } from "./mergeConfig";
//by id
// export const getProductConfig = (subcategoryId) => {

//     if (!subcategoryId) {
//         return INDUSTRY_TEMPLATES.default;
//     }

//     const template =
//         INDUSTRY_TEMPLATES[subcategoryId] ||
//         INDUSTRY_TEMPLATES.default;

//     const override =
//         OVERRIDES[subcategoryId] || {};

//     return mergeConfig(template, override);
// };


export const getProductConfig = (subcategorySlug) => {

    if (!subcategorySlug) {
        return INDUSTRY_TEMPLATES.default;
    }


    const template =INDUSTRY_TEMPLATES[subcategorySlug] || INDUSTRY_TEMPLATES.default;


    // const override = OVERRIDES[subcategorySlug] || {};


    // return mergeConfig(template, override);
    return mergeConfig(template,{});
};